/**
 * ENUMS - Clean Architecture
 * 
 * Valores constantes usados en toda la aplicación
 */

// ============================================
// USER & AUTH
// ============================================

export enum UserRole {
  USER = 'user',
  THERAPIST = 'therapist',
  THERAPIST_ASSISTANT = 'therapist_assistant',
  SCHOOL_ADMIN = 'school_admin',
  ADMIN = 'admin'
}

export enum UserStatus {
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  DELETED = 'deleted',
  PENDING_VERIFICATION = 'pending_verification'
}

// ============================================
// SUBSCRIPTION
// ============================================

export enum SubscriptionPlan {
  TRIAL = 'trial',
  STARTER = 'starter',
  PRO = 'pro',
  ENTERPRISE = 'enterprise'
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  TRIAL = 'trial',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
  PAST_DUE = 'past_due'
}

// ============================================
// PATIENT & THERAPY
// ============================================

export enum PatientStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
  DISCHARGED = 'discharged'
}

export enum SessionType {
  INITIAL = 'initial',
  FOLLOWUP = 'followup',
  EMERGENCY = 'emergency',
  GROUP = 'group'
}

// ============================================
// PRACTICES
// ============================================

export enum PracticeVisibility {
  PUBLIC = 'public',
  THERAPIST_ONLY = 'therapist_only',
  PRIVATE = 'private'
}

export enum PracticeDifficulty {
  BEGINNER = 'beginner',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced'
}

export enum AssignmentFrequency {
  ONCE = 'once',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  BIWEEKLY = 'biweekly',
  MONTHLY = 'monthly'
}

// ============================================
// NOTIFICATIONS
// ============================================

export enum NotificationType {
  PRACTICE_DUE = 'practice_due',
  SESSION_REMINDER = 'session_reminder',
  THERAPIST_MESSAGE = 'therapist_message',
  APPOINTMENT_CHANGE = 'appointment_change'
}

// ============================================
// PERMISSIONS
// ============================================

export enum Permission {
  // Therapist permissions
  CAN_MANAGE_PATIENTS = 'can_manage_patients',
  CAN_ACCESS_ANALYTICS = 'can_access_analytics',
  CAN_GENERATE_CONTENT = 'can_generate_content',
  CAN_ASSIGN_PRACTICES = 'can_assign_practices',

  // School permissions
  CAN_MANAGE_SCHOOL = 'can_manage_school',
  CAN_CREATE_COURSES = 'can_create_courses',
  CAN_MANAGE_PRACTICES = 'can_manage_practices',

  // Circle permissions
  CAN_CREATE_CIRCLES = 'can_create_circles',
  CAN_JOIN_CIRCLES = 'can_join_circles',
  CAN_POST_IN_CIRCLES = 'can_post_in_circles',
  CAN_CREATE_PROFESSIONAL_CIRCLES = 'can_create_professional_circles',
  CAN_MODERATE_CIRCLES = 'can_moderate_circles',

  // Admin permissions
  CAN_MANAGE_USERS = 'can_manage_users',
  CAN_MANAGE_ROLES = 'can_manage_roles',
  CAN_MANAGE_CONTENT = 'can_manage_content',
  CAN_VIEW_ALL_ANALYTICS = 'can_view_all_analytics',
  CAN_MANAGE_BILLING = 'can_manage_billing'
}
